import WebApi from 'core/services/WebApi';
import { AlertType } from 'core/redux/reducers/layout/type';
import { setAlert } from 'core/redux/actions/lyaout/action';
import { AppThunk } from 'redux/store';
import {
  GetListOfEducationType,
  GetListOfMaritalStatusesType,
  GetListOfStatesType,
  GetPaymentSubscription,
  GetUserApplications,
  GetUserLoans,
  GetListOfLoanPurposesType,
  IExtendApplication,
  IPostCreateApplicationType,
  IRepaymentApplication,
  PostInitEsignType,
  TypesUserApplication,
  GetSummaryApplication,
  PostUserFeedbackType,
  GetPaymentPlanInfo,
  GetCustomPaymentInfoType,
  CreateCustomPaymentLinkType,
} from './type';
import { GetListOfBanksType } from './type';
import { IPaymentLink, PaymentStatus } from '../../reducers/userApplications/type';
import { getDelay } from 'utils/functions/getDelay';
import { PostConfirmationCodeApplicationType } from '../user/type';
import { DictionaryTypes } from 'types';
import {
  downloadBlobFile,
  removeCalculatorData,
  removeIsRetryAfterExist,
  removeStorageSaveInitValue,
} from 'utils';
import { PAYMENT_GATEWAY } from 'const';
import { removeRetryAfter, saveRetryAfter, setAlertWithTimer } from '../index';

export const getUserLoans: GetUserLoans = () => (dispatch, getState) => {
  dispatch({ type: TypesUserApplication.GET_USER_LOANS_REQUEST });
  const state = getState();
  const { id } = state.user.userInfo;

  return WebApi.request({
    method: 'GET',
    url: `/api/users/${id}/loans`,
    onSuccess: (data) => {
      dispatch({ type: TypesUserApplication.GET_USER_LOANS_SUCCESS, data });
    },
    onFailed: () => {
      dispatch({ type: TypesUserApplication.GET_USER_LOANS_ERROR });
    },
    isAuth: true,
  });
};

export const getLoanInfo = (): AppThunk<void> => (dispatch, getState) => {
  dispatch({ type: TypesUserApplication.GET_USER_LOAN_INFO_REQUEST });
  const state = getState();
  const { id } = state.userApplications.loanHistory[0];

  return WebApi.request({
    method: 'GET',
    url: `/api/loans/${id}/info`,
    onSuccess: (data) => {
      dispatch({ type: TypesUserApplication.GET_USER_LOAN_INFO_SUCCESS, data });
    },
    onFailed: () => {
      dispatch({ type: TypesUserApplication.GET_USER_LOAN_INFO_ERROR });
    },
    isAuth: true,
  });
};

export const getUserApplications: GetUserApplications = () => (dispatch, getState) => {
  dispatch({ type: TypesUserApplication.GET_USER_APPLICATIONS_REQUEST });
  const state = getState();
  const { id } = state.user.userInfo;

  return WebApi.request({
    method: 'GET',
    url: `/api/users/${id}/applications`,

    onSuccess: (data) => {
      dispatch({
        type: TypesUserApplication.GET_USER_APPLICATIONS_SUCCESS,
        data,
      });
      dispatch(getUserLoans());
    },
    onFailed: () => {
      dispatch({
        type: TypesUserApplication.GET_USER_APPLICATIONS_ERROR,
        data: {
          request_error: 'error_message_an_error_occurred',
          isLoadingApplications: false,
          isFailedApplications: true,
          isLoadedApplications: true,
        },
      });
    },

    isAuth: true,
  });
};

export const getPaymentPlanInfo: GetPaymentPlanInfo = () => (dispatch, getState) => {
  dispatch({ type: TypesUserApplication.GET_PAYMENT_PLAN_INFO_REQUEST });
  const state = getState();

  //@ts-ignore
  const { id } = state?.userApplications?.loanActive;

  return WebApi.request({
    method: 'GET',
    url: `/api/loans/${id}/payment_plan`,

    onSuccess: (data) => {
      dispatch({
        type: TypesUserApplication.GET_PAYMENT_PLAN_INFO_SUCCESS,
        data,
      });
    },
    onFailed: () => {
      dispatch({
        type: TypesUserApplication.GET_PAYMENT_PLAN_INFO_ERROR,
      });
    },
    isAuth: true,
  });
};

export const getALLApplicationAgreements = (): AppThunk<void> => (dispatch, getState) => {
  const state = getState();
  const { id } = state.user.userInfo;

  return WebApi.request({
    method: 'GET',
    url: `/api/users/${id}/agreements`,
    onSuccess: (data) => {
      dispatch({ type: TypesUserApplication.GET_ALL_APPLICATION_AGREEMENTS_SUCCESS, data });
    },
    onFailed: () => {
      dispatch({ type: TypesUserApplication.GET_ALL_APPLICATION_AGREEMENTS_ERROR });
    },
    isAuth: true,
  });
};

export const getApplicationAgreements = (): AppThunk<void> => (dispatch, getState) => {
  const state = getState();

  const applicationActive = state.userApplications.applications[0];

  return (
    applicationActive?.id &&
    WebApi.request({
      method: 'GET',
      url: `/api/applications/${applicationActive.id}/agreements`,
      onSuccess: (data) => {
        dispatch({ type: TypesUserApplication.GET_APPLICATION_AGREEMENTS_SUCCESS, data });
      },
      onFailed: () => {
        dispatch({ type: TypesUserApplication.GET_APPLICATION_AGREEMENTS_ERROR });
      },
      isAuth: true,
    })
  );
};

export const postCreateApplication: IPostCreateApplicationType =
  (params) => (dispatch, getState) => {
    const { data, onFailed, onSuccess } = params;

    const state = getState();

    const { id } = state.user.userInfo;

    dispatch({ type: TypesUserApplication.POST_CREATE_APPLICATION_REQUEST });

    return WebApi.request({
      method: 'POST',
      url: `/api/users/${id}/application`,
      data,
      onSuccess: (data) => {
        dispatch({ type: TypesUserApplication.POST_CREATE_APPLICATION_SUCCESS, data });
        dispatch(() => removeCalculatorData());
        onSuccess && onSuccess();
      },
      onFailed: (error) => {
        if (error.data.status === 400) {
          const alert = {
            textData: {
              message: error.data.message,
            },
            type: AlertType.Error,
          };

          dispatch(setAlert(alert));
        }

        dispatch({ type: TypesUserApplication.POST_CREATE_APPLICATION_ERROR });
        onFailed && onFailed(error);
      },
      isAuth: true,
    });
  };

export const postCreatePaymentLink =
  (data: IPaymentLink): AppThunk<void> =>
  (dispatch) => {
    dispatch({ type: TypesUserApplication.POST_CREATE_PAYMENTLINK_REQUEST });

    return WebApi.request({
      method: 'POST',
      url: `/api/payment_links`,
      data,
      onSuccess: (data) => {
        dispatch({ type: TypesUserApplication.POST_CREATE_PAYMENTLINK_SUCCESS, data });
      },
      onFailed: () => {
        dispatch({ type: TypesUserApplication.POST_CREATE_PAYMENTLINK_ERROR });
      },
      isAuth: true,
    });
  };

export const postRepaymentApplication =
  (data: IRepaymentApplication, onFailed: (errors: any) => void): AppThunk<void> =>
  (dispatch, getState) => {
    dispatch({ type: TypesUserApplication.POST_REPAYMENT_APPLICATION_REQUEST });

    const state = getState();

    const loanActive = state.userApplications.loanActive;

    data = {
      ...data,
      gateway: PAYMENT_GATEWAY,
    };

    return (
      loanActive?.id &&
      WebApi.request({
        method: 'POST',
        url: `/api/loans/${loanActive.id}/payment_requests`,
        data,
        onSuccess: (data) => {
          dispatch({ type: TypesUserApplication.POST_REPAYMENT_APPLICATION_SUCCESS, data });
        },
        onFailed: (error) => {
          dispatch({ type: TypesUserApplication.POST_REPAYMENT_APPLICATION_ERROR });

          onFailed && onFailed(error);
        },
        isAuth: true,
      })
    );
  };

export const postExtendApplication =
  (data: IExtendApplication, onFailed: (errors: any) => void): AppThunk<void> =>
  (dispatch, getState) => {
    dispatch({ type: TypesUserApplication.POST_PAYMENT_APPLICATION_REQUEST });

    const state = getState();

    const loanActive = state.userApplications.loanActive;

    const params = { ...data, gateway: PAYMENT_GATEWAY };

    const { tenor } = params;

    const isZeroAmount = params.amount === 0;

    const extendsPath = isZeroAmount ? 'extensions' : 'payment_requests';

    return (
      loanActive?.id &&
      WebApi.request({
        method: 'POST',
        url: `/api/loans/${loanActive.id}/${extendsPath}`,
        data: isZeroAmount ? { tenor } : params,
        onSuccess: (data) => {
          dispatch({ type: TypesUserApplication.POST_PAYMENT_APPLICATION_SUCCESS, data });
        },
        onFailed: (error) => {
          dispatch({ type: TypesUserApplication.POST_PAYMENT_APPLICATION_ERROR });

          onFailed && onFailed(error);
        },
        isAuth: true,
      })
    );
  };

export const getPaymentRequestStatus =
  (id: number): AppThunk<void> =>
  (dispatch) => {
    dispatch({ type: TypesUserApplication.GET_LOANS_PAYMENTS_REQUEST });

    return WebApi.request({
      method: 'GET',
      url: `/api/loans/${id}/payment_request_status`,

      onSuccess: (data) => {
        const getRetry = async () => {
          await getDelay(3000);
          dispatch(getPaymentRequestStatus(id));
        };

        switch (data.status) {
          case PaymentStatus.UNKNOWN || PaymentStatus.ACTIVE:
            dispatch({ type: TypesUserApplication.GET_LOANS_PAYMENTS_SUCCESS, data });
            return getRetry();

          case PaymentStatus.PAID:
            return dispatch({ type: TypesUserApplication.GET_LOANS_PAYMENTS_SUCCESS, data });

          default:
            dispatch({
              type: TypesUserApplication.GET_LOANS_PAYMENTS_ERROR,
              data: { request_error: 'error_message_an_error_occurred' },
            });
        }
      },
      onFailed: () => {
        dispatch({
          type: TypesUserApplication.GET_LOANS_PAYMENTS_ERROR,
          data: { request_error: 'error_message_an_error_occurred' },
        });
      },
      isAuth: true,
    });
  };

export const getPaymentSubscription: GetPaymentSubscription = () => (dispatch, getState) => {
  const state = getState();

  const applicationActive = state.userApplications.applications[0];

  return (
    applicationActive?.id &&
    WebApi.request({
      method: 'GET',
      url: `/api/applications/${applicationActive.id}/payment_subscription`,

      onSuccess: (data) => {
        dispatch({
          type: TypesUserApplication.GET_PAYMENT_SUBSCRIPTION_SUCCESS,
          data: { ...data, request_success: 'request_success' },
        });
      },

      onFailed: () => {
        dispatch({ type: TypesUserApplication.GET_PAYMENT_SUBSCRIPTION_ERROR });
      },

      isAuth: true,
    })
  );
};

export const postSkipPaymentSubscription = (): AppThunk<void> => (dispatch, getState) => {
  const state = getState();

  const activeApplicationId = state.userApplications.applications[0].id;

  dispatch({ type: TypesUserApplication.POST_SKIP_PAYMENT_SUBSCRIPTION_REQUEST });

  return WebApi.request({
    method: 'POST',
    url: `/api/applications/${activeApplicationId}/bypass_bank_approval`,

    onSuccess: (data) => {
      dispatch({ type: TypesUserApplication.POST_SKIP_PAYMENT_SUBSCRIPTION_SUCCESS, data });
      removeStorageSaveInitValue();
    },

    onFailed: (error) => {
      dispatch({ type: TypesUserApplication.POST_SKIP_PAYMENT_SUBSCRIPTION_ERROR, error });
    },
    isAuth: true,
  }).then(() => dispatch(getPaymentSubscription()));
};

export const postInitEsign: PostInitEsignType =
  (params = {}) =>
  (dispatch, getState) => {
    const { onSuccess, onFailed } = params;

    const state = getState();

    const applicationAgreements = state.userApplications.applicationAgreements;
    return (
      applicationAgreements &&
      WebApi.request({
        method: 'POST',
        url: `/api/agreements/${Object.values(applicationAgreements)[0].id}/init_esign`,

        onSuccess: (data) => {
          onSuccess && onSuccess();
          dispatch({
            type: TypesUserApplication.POST_INIT_ESIGN_SUCCESS,
            data,
          });
        },

        onFailed: () => {
          onFailed && onFailed();
          dispatch({ type: TypesUserApplication.POST_INIT_ESIGN_ERROR });
        },

        isAuth: true,
      })
    );
  };

export const getDownloadSignedDocuments =
  (agreementId: number, agreementName: string): AppThunk<void> =>
  (dispatch, getState) => {
    const state = getState();

    const applicationAgreements = state.userApplications.applicationAgreements;

    dispatch({ type: TypesUserApplication.GET_DOWNLOAD_SIGNED_DOCUMENTS_REQUEST });

    return (
      applicationAgreements &&
      WebApi.request({
        method: 'GET',
        url: `/api/agreements/${agreementId}/download_signed`,
        responseType: 'blob',
        headers: { 'Content-Type': 'application/pdf' },

        onSuccess: (data) => {
          downloadBlobFile(data, `${agreementName}_${agreementId}.pdf`);
          setTimeout(
            () =>
              dispatch({
                type: TypesUserApplication.GET_DOWNLOAD_SIGNED_DOCUMENTS_SUCCESS,
                data,
              }),
            1000
          );
        },

        onFailed: () => {
          dispatch({ type: TypesUserApplication.GET_DOWNLOAD_SIGNED_DOCUMENTS_ERROR });
        },

        isAuth: true,
      })
    );
  };
export const getDownloadApplicationAgreements =
  (agreementId: number, agreementName: string): AppThunk<void> =>
  (dispatch, getState) => {
    const state = getState();

    const applicationAgreements = state.userApplications.applicationAgreements;

    dispatch({ type: TypesUserApplication.GET_DOWNLOAD_AGREEMENTS_REQUEST });

    return (
      applicationAgreements &&
      WebApi.request({
        method: 'GET',
        url: `/api/agreements/${agreementId}/download`,
        responseType: 'blob',
        headers: { 'Content-Type': 'application/pdf' },

        onSuccess: (data) => {
          downloadBlobFile(data, `${agreementName} ${agreementId}.pdf`);
          setTimeout(
            () =>
              dispatch({
                type: TypesUserApplication.GET_DOWNLOAD_AGREEMENTS_SUCCESS,
                data,
              }),
            1000
          );
        },

        onFailed: () => {
          dispatch({ type: TypesUserApplication.GET_DOWNLOAD_AGREEMENTS_ERROR });
        },

        isAuth: true,
      })
    );
  };

export const getDownloadExperianReport = (): AppThunk<void> => (dispatch, getState) => {
  const state = getState();

  const id = state.user.userInfo.id;

  dispatch({ type: TypesUserApplication.GET_DOWNLOAD_EXPERIAN_REPORT_REQUEST });

  return WebApi.request({
    method: 'GET',
    url: `/api/kyc/experian/download_pdf_report/${id}`,
    responseType: 'blob',
    headers: { 'Content-Type': 'application/pdf' },

    onSuccess: (data) => {
      downloadBlobFile(data, `experian-report.pdf`);
      dispatch({
        type: TypesUserApplication.GET_DOWNLOAD_EXPERIAN_REPORT_SUCCESS,
        data,
      });
    },

    onFailed: () => {
      const alert = {
        textData: {
          message: 'An error occurred. Please, try again.',
        },
        type: AlertType.Error,
      };

      dispatch(setAlert(alert));

      dispatch({ type: TypesUserApplication.GET_DOWNLOAD_EXPERIAN_REPORT_ERROR });
    },

    isAuth: true,
  });
};

export const xDryRunConfirmationCodeApplication =
  (onFailed?: (error: any) => void): AppThunk<void> =>
  (dispatch, getState) => {
    const state = getState();

    const applicationActive = state.userApplications.applications[0].id;

    return WebApi.request({
      method: 'GET',
      url: `/api/applications/${applicationActive}/confirmation_code`,
      headers: { 'X-Dry-Run': 1 },
      onSuccess: () => {},
      onFailed: (error) => {
        onFailed && onFailed(error);
      },
      isAuth: true,
    });
  };

export const xDryRunGetConfirmationCodeApplication = (): AppThunk => (dispatch, getState) => {
  const state = getState();
  const applicationActive = state.userApplications.applications[0].id;

  return WebApi.request({
    method: 'GET',
    url: `/api/applications/${applicationActive}/confirmation_code`,
    headers: { 'X-Dry-Run': 1 },

    isAuth: true,
  });
};

export const getConfirmationCodeApplication =
  (onFailed?: (error: any) => void): AppThunk<void> =>
  async (dispatch, getState) => {
    const state = getState();

    const applicationActive = state.userApplications.applications[0].id;

    dispatch({ type: TypesUserApplication.GET_CONFIRM_CODE_APPLICATION_REQUEST });

    const response = await WebApi.request({
      method: 'GET',
      url: `/api/applications/${applicationActive}/confirmation_code`,
      onSuccess: () => {
        dispatch(removeRetryAfter());
        removeIsRetryAfterExist();

        dispatch({ type: TypesUserApplication.GET_CONFIRM_CODE_APPLICATION_SUCCESS });
      },
      onFailed: (error) => {
        if (error.data.status === 429) {
          setAlertWithTimer(error);
        }

        dispatch({ type: TypesUserApplication.GET_CONFIRM_CODE_APPLICATION_ERROR });

        onFailed && onFailed(error);
      },
      onFinally: () => {},
      isAuth: true,
    });

    const retryAfter = response.request.getResponseHeader('retry-after');

    !!retryAfter && dispatch(saveRetryAfter(retryAfter));
  };

export const postConfirmationCodeApplication: PostConfirmationCodeApplicationType =
  (data) => async (dispatch, getState) => {
    const { confirmation_code, onSuccess, onFailed } = data;
    const state = getState();

    const applicationActive = state.userApplications.applications[0].id;

    const response = await WebApi.request({
      method: 'POST',
      url: `/api/applications/${applicationActive}/confirmation_code`,
      data: { confirmation_code },
      onSuccess: () => {
        onSuccess && onSuccess();
        dispatch({ type: TypesUserApplication.POST_CONFIRM_CODE_APPLICATION_SUCCESS });
        dispatch(getApplicationAgreements());
        removeStorageSaveInitValue();
      },
      onFailed: (error) => {
        if (error.data.status === 429) {
          setAlertWithTimer(error);
        }

        onFailed && onFailed(error);
        dispatch({ type: TypesUserApplication.POST_CONFIRM_CODE_APPLICATION_ERROR });
      },
      isAuth: true,
    });

    const retryAfter = response.request.getResponseHeader('retry-after');

    !!retryAfter && dispatch(saveRetryAfter(retryAfter));
  };

export const getListOfBanks: GetListOfBanksType = () => (dispatch) => {
  return WebApi.request({
    method: 'GET',
    url: `/api/dictionary/banks`,
    onSuccess: (data) => {
      dispatch({ type: TypesUserApplication.GET_LIST_OF_BANKS_SUCCESS, data });
    },
    onFailed: () => {
      dispatch({ type: TypesUserApplication.GET_LIST_OF_BANKS_ERROR });
    },
    isAuth: true,
  });
};

export const getListOfLoanPurposes: GetListOfLoanPurposesType = () => (dispatch) => {
  return WebApi.request({
    method: 'GET',
    url: `/api/dictionary/${DictionaryTypes.Loan_purpose}`,
    onSuccess: (data) => {
      dispatch({ type: TypesUserApplication.GET_LIST_OF_LOAN_PURPOSES_SUCCESS, data });
    },
    onFailed: () => {
      dispatch({ type: TypesUserApplication.GET_LIST_OF_LOAN_PURPOSES_ERROR });
    },
    isAuth: true,
  });
};

export const getListOfEducations: GetListOfEducationType = () => (dispatch) => {
  return WebApi.request({
    method: 'GET',
    url: `/api/dictionary/${DictionaryTypes.Education}`,
    onSuccess: (data) => {
      dispatch({ type: TypesUserApplication.GET_LIST_OF_EDUCATION_SUCCESS, data });
    },
    onFailed: () => {
      dispatch({ type: TypesUserApplication.GET_LIST_OF_EDUCATION_ERROR });
    },
    isAuth: true,
  });
};

export const getListOfMaritalStatuses: GetListOfMaritalStatusesType = () => (dispatch) => {
  return WebApi.request({
    method: 'GET',
    url: `/api/dictionary/${DictionaryTypes.Marital_status}`,
    onSuccess: (data) => {
      dispatch({ type: TypesUserApplication.GET_LIST_OF_MARITAL_STATUS_SUCCESS, data });
    },
    onFailed: () => {
      dispatch({ type: TypesUserApplication.GET_LIST_OF_MARITAL_STATUS_ERROR });
    },
    isAuth: true,
  });
};

export const getListOfStates: GetListOfStatesType = () => (dispatch) => {
  return WebApi.request({
    method: 'GET',
    url: `/api/dictionary/location/states`,
    onSuccess: (data) => {
      dispatch({ type: TypesUserApplication.GET_LIST_OF_STATES_SUCCESS, data });
    },
    onFailed: () => {
      dispatch({
        type: TypesUserApplication.GET_LIST_OF_STATES_ERROR,
      });
    },
    isAuth: true,
  });
};

export const postFinbitRequest = (): AppThunk<void> => (dispatch, getState) => {
  const state = getState();

  const { id } = state.user.userInfo;

  dispatch({ type: TypesUserApplication.POST_FINBIT_REQUEST });

  return WebApi.request({
    method: 'POST',
    url: `/api/users/${id}/finbit_request`,
    data: {},
    onSuccess: (data) => {
      dispatch({ type: TypesUserApplication.POST_FINBIT_SUCCESS, data });
    },
    onFailed: (error) => {
      dispatch({ type: TypesUserApplication.POST_FINBIT_ERROR, error });
    },
    isAuth: true,
  });
};

export const getFinbitRequest = (): AppThunk<void> => (dispatch, getState) => {
  const state = getState();

  const { id } = state.user.userInfo;

  dispatch({ type: TypesUserApplication.GET_FINBIT_REQUEST });

  return WebApi.request({
    method: 'GET',
    url: `/api/users/${id}/finbit_request`,
    onSuccess: (data) => {
      dispatch({ type: TypesUserApplication.GET_FINBIT_SUCCESS, data });
    },
    onFailed: (error) => {
      dispatch({ type: TypesUserApplication.GET_FINBIT_ERROR, error });
    },
    isAuth: true,
  });
};

export const getSummaryApplication: GetSummaryApplication = () => (dispatch, getState) => {
  const state = getState();

  const applicationActive = state.userApplications.applications[0];

  return (
    applicationActive?.id &&
    WebApi.request({
      method: 'GET',
      url: `/api/applications/${applicationActive.id}/summary`,
      onSuccess: (data) => {
        dispatch({ type: TypesUserApplication.GET_SUMMARY_APPLICATION_SUCCESS, data });
      },
      onFailed: () => {
        dispatch({ type: TypesUserApplication.GET_SUMMARY_APPLICATION_ERROR });
      },
      isAuth: true,
    })
  );
};

export const postUserFeedback: PostUserFeedbackType = (params) => (dispatch, getState) => {
  const { onFailed, onSuccess, ...rest } = params;
  const state = getState();

  const id = state.userApplications.applications[0].id;

  return WebApi.request({
    method: 'POST',
    url: `/api/applications/${id}/feedback`,
    data: rest,
    onSuccess: (data) => {
      onSuccess && onSuccess();
      dispatch({ type: TypesUserApplication.POST_USER_FEEDBACK_SUCCESS, data });
    },
    onFailed: () => {
      onFailed && onFailed();
      dispatch({ type: TypesUserApplication.POST_USER_FEEDBACK_ERROR });
    },
  });
};

export const getCustomPaymentInfo: GetCustomPaymentInfoType =
  (params): AppThunk<void> =>
  (dispatch) => {
    dispatch({ type: TypesUserApplication.GET_CUSTOM_PAYMENT_INFO_REQUEST });

    const { onFailed, onSuccess, slug } = params;

    return WebApi.request({
      method: 'GET',
      url: `api/loan/${slug}/custom-payment-info`,

      onSuccess: (data) => {
        onSuccess && onSuccess(data);
        dispatch({ type: TypesUserApplication.GET_CUSTOM_PAYMENT_INFO_SUCCESS, data });
      },

      onFailed: (error) => {
        onFailed && onFailed(error);
        dispatch({ type: TypesUserApplication.GET_CUSTOM_PAYMENT_INFO_ERROR });
      },
    });
  };

export const postCreateCustomPaymentLink: CreateCustomPaymentLinkType =
  (params): AppThunk<void> =>
  (dispatch) => {
    dispatch({ type: TypesUserApplication.POST_CREATE_CUSTOM_PAYMENT_LINK_REQUEST });

    const { onFailed, onSuccess, slug, amount } = params;

    return WebApi.request({
      method: 'POST',
      url: `api/loan/${slug}/payment-link`,
      data: { amount },
      onSuccess: (data) => {
        onSuccess && onSuccess();
        dispatch({ type: TypesUserApplication.POST_CREATE_CUSTOM_PAYMENT_LINK_SUCCESS, data });
      },

      onFailed: () => {
        onFailed && onFailed();
        dispatch({ type: TypesUserApplication.POST_CREATE_CUSTOM_PAYMENT_LINK_ERROR });
      },
    });
  };

export const getCashFreePaymentSession =
  (slug: string, paymentLinkId: number): AppThunk<void> =>
  (dispatch) => {
    dispatch({ type: TypesUserApplication.GET_CASH_FREE_PAYMENT_SESSION_REQUEST });

    return WebApi.request({
      method: 'GET',
      url: `api/loan/${slug}/payment-link/${paymentLinkId}`,

      onSuccess: (data) => {
        dispatch({ type: TypesUserApplication.GET_CASH_FREE_PAYMENT_SESSION_SUCCESS, data });
      },

      onFailed: () => {
        dispatch({ type: TypesUserApplication.GET_CASH_FREE_PAYMENT_SESSION_ERROR });
      },
    });
  };
